import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { Divider, TextField, IconButton } from "@mui/material";
import CreateEditIndividualCustomerDate from "./CreateEditIndividualCustomerDate";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCGState } from "../customerGroupSetupSlice";
import { useEffect } from "react";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../../../components/ui/CustomButton";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 1300,
	height: 560,
	bgcolor: "background.paper",
	borderRadius: 2,
	boxShadow: 24,
	p: 4,
};

export default function CreateBasicModal() {
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const { selCustomers, createFromDate, createToDate, createIndDateUpdated } =
		cgState;
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;

	const isRestrictedAccess = setAccess;
	const [open, setOpen] = React.useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [tempCustomers, setTempCustomers] = useState(selCustomers);
	const [validationError, setValidationError] = useState("");

	useEffect(() => {
		setTempCustomers(selCustomers);
	}, [selCustomers]);

	function showMessage(message, severity) {
		dispatch(setCGState("popUpMsg", message));
		dispatch(setCGState("popUpSeverity", severity));
		dispatch(setCGState("popUpOpen", true));
	}

	const handleClose = () => {
		setOpen(false);
		setTempCustomers(selCustomers);
	};
	const handleSearchChange = (event) => {
		setSearchQuery(event.target.value);
	};
	const handleOpen = () => {
		setSearchQuery("");
		setOpen(true);
	};

	useEffect(() => {
		if (createIndDateUpdated) {
			setTempCustomers(selCustomers);
		}
	}, [createIndDateUpdated, setTempCustomers]);

	const handleSave = () => {
		let errorOccured = false;

		const invalidCustomer = tempCustomers.find((customer) =>
			dayjs(customer.effectiveStartDate)
				.startOf("day")
				.isAfter(dayjs(customer.effectiveEndDate).startOf("day"))
		);

		if (invalidCustomer) {
			showMessage(
				"The customer effective end date cannot be less than the start date",
				"error"
			);
			setOpen(true);
			errorOccured = true;
		}

		if (errorOccured) return;

		const startDateValidationError = tempCustomers.find((customer) =>
			dayjs(customer.effectiveStartDate)
				.startOf("day")
				.isBefore(dayjs(createFromDate).startOf("day"))
		);

		if (startDateValidationError) {
			showMessage(
				"The Customer effective start date falls outside the effective start date of customer group",
				"error"
			);
			setOpen(true);
			errorOccured = true;
		}

		if (errorOccured) return;

		const endDateValidationError = tempCustomers.find((customer) =>
			dayjs(customer.effectiveEndDate)
				.startOf("day")
				.isAfter(dayjs(createToDate).startOf("day"))
		);

		if (endDateValidationError) {
			showMessage(
				"The Customer effective end date falls outside the effective end date of customer group",
				"error"
			);
			setOpen(true);
			errorOccured = true;
		}

		if (errorOccured) return;

		const isStartDateMatched = tempCustomers.some((customer) =>
			dayjs(customer.effectiveStartDate)
				.startOf("day")
				.isSame(dayjs(createFromDate).startOf("day"))
		);

		if (!isStartDateMatched) {
			showMessage(
				"At least one Customer effective start date has to match with the start date of customer group",
				"error"
			);
			setOpen(true);
			errorOccured = true;
		}

		const isEndDateMatched = tempCustomers.some((customer) =>
			dayjs(customer.effectiveEndDate)
				.startOf("day")
				.isSame(dayjs(createToDate).startOf("day"))
		);

		if (!isEndDateMatched) {
			showMessage(
				"At least one Customer effective end date has to match with the end date of customer group",
				"error"
			);
			setOpen(true);
			errorOccured = true;
		}

		if (!errorOccured) {
			dispatch(setCGState("selCustomers", tempCustomers));
			dispatch(setCGState("createIndDateUpdated", true));
			setOpen(false);
		}
	};

  const loadMore = (startIndex, stopIndex) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newItems = selCustomers.slice(startIndex, stopIndex + 1);
  
        setTempCustomers((prev) => {
          const existingIds = new Set(prev.map((c) => c.customerID));
          const merged = [...prev];
          newItems.forEach((item) => {
            if (!existingIds.has(item.customerID)) {
              merged.push(item);
            }
          });
          return merged;
        });
  
        resolve();
      }, 300);
    });
  };

	return (
		<div>
			<CustomButton
				startIcon={<EditCalendarIcon />}
				disabled={!isRestrictedAccess}
				sx={{ mt: 2, ml: "calc(100% - 165px)" }}
				onClick={handleOpen}
			>
				Update Dates
			</CustomButton>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<IconButton
						onClick={handleClose}
						sx={{
							position: "absolute",
							top: 10,
							right: 10,
							zIndex: 1,
							color: "grey",
						}}
					>
						<CloseIcon />
					</IconButton>
					<Typography
						sx={{ ml: 1, fontWeight: "bold", color: "darkred.light" }}
					>
						Edit Customer Start Date / End Date
					</Typography>
					<Divider sx={{ mb: 3 }} />
					<TextField
						label="Search"
						variant="outlined"
						size="small"
						fullWidth
						sx={{
							mb: 2,
							mt: -1,
							"& .MuiOutlinedInput-root": {
								"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
									borderColor: "darkred.main !important",
								},
							},
						}}
						value={searchQuery}
						onChange={handleSearchChange}
						InputProps={{ autoComplete: "off" }}
					/>
					{/* <CreateAutoComplete /> */}
					<CreateEditIndividualCustomerDate
						searchQuery={searchQuery}
						tempCustomers={tempCustomers}
						setTempCustomers={setTempCustomers}
            loadMore={loadMore}
					/>
					<Box>
						<CustomButton
							sx={{
								position: "fixed",
								bottom: 10,
								right: 20,
								zIndex: 1,
							}}
							onClick={handleSave}
						>
							Save Dates
						</CustomButton>
					</Box>
				</Box>
			</Modal>
		</div>
	);
}
